/**
 * Labstep
 *
 * @module prosemirror/components/Menu/Link/Action/Edit
 * @desc Button to edit a link mark
 */

import { FieldType } from 'labstep-web/constants/form';
import { Button } from 'labstep-web/core/Button';
import { FormReusable } from 'labstep-web/core/Form/Reusable';
import type { FieldWithoutActionProps } from 'labstep-web/core/Form/Reusable/types';
import { Icon } from 'labstep-web/core/Icon';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import { setMarkFromSelectedNode } from 'labstep-web/prosemirror/utils/selection';
import type React from 'react';
import { string } from 'yup';
import type { IMenuLinkActionEditProps } from './types';

export const fieldUrl: FieldWithoutActionProps = {
  fieldType: FieldType.Text,
  name: 'url',
  validation: string().url().required(),
  placeholder: 'Paste or type your link',
  fieldLabel: 'Web address',
};

export const MenuLinkActionEdit: React.FC<
  IMenuLinkActionEditProps
> = ({ state, dispatch, attrs }) => (
  <Modal
    viewComponent={({ toggleModal }) => (
      <Button onMouseDown={toggleModal}>
        <Icon name="pencil" />
        <span>Edit</span>
      </Button>
    )}
    header="Edit link"
    content={({ toggleModal }) => (
      <FormReusable
        fields={[fieldUrl]}
        onSubmit={({ url }) => {
          setMarkFromSelectedNode(state.schema.marks.link, {
            ...attrs,
            href: url,
          })(state, dispatch);
          toggleModal();
        }}
        submitButtonText="Update"
        defaultValues={{ url: attrs.href }}
      />
    )}
  />
);
